import { Navigate, Outlet, useLocation } from "react-router-dom";
import { usePermissions } from "../context/PermissionContext";
import MasterLayout from "../masterLayout/MasterLayout";
import LoadingComponent from "../components/ui/LoadingComponent";
import { useEffect } from "react";
export const routePermissions = {
  // Main Page
  "/dashboard": "view_dashboard",
  "/home": "view_home",
  "/user-profile": "view_profile",
  "/branches-hierarchy": "branches_hierarchy",
  "/redeem-requestes": "redeem_request",
  "/receipt": "receipt_ui",
  // Incentive
  "/incentive-plan": "view_incentive",
  "/add-incentive-plan": "add_incentive",
  "/edit-incentive-plan": "update_incentive",
  "/incentive-assginment": "view_incentive_assignment",
  "/add-incentive-assgiment": "add_incentive_assignment",
  "/my-incentive-wallet": "my_incentive_wallet",
  // Staff Roles
  "/staff-roles": "view_staff_roles",
  "/staff-role-create": "add_staff_role",
  "/staff-role-edit": "update_staff_role",
  // Staff
  "/staff": "view_staff",
  "/staff-create": "add_staff",
  "/staff-edit": "update_staff",
  "/staff-details": "view_staff_details",
  // Staff Branch
  "/staff-branches": "view_staff_branches",
  "/staff-branch-assign": "assign_staff_branch",
  // Staff Reports
  "/revenue-reports": "view_revenue_report",
  "/staff-attendence": "view_staff_attendance",
  // Location & Operation
  "/branch-list": "view_client_branches",
  "/branch-create": "add_client_branch",
  "/branch-edit": "update_client_branch",
  "/branch-locations": "view_branch_locations",
  "/branch-location-edit": "update_branch_location",
  "/branch-location-create": "add_branch_location",
  "/slots": "view_slots",
  "/slot-create": "add_slot",
  "/slot-edit": "update_slot",
  // Customer & Billing
  "/customer-profiles": "view_customer_profile",
  "/customer-profile-create": "add_customer_profile",
  "/customer-profile-edit": "update_customer_profile",
  "/vehicle-pricing": "view_vehicle_pricing",
  "/subscription": "view_subscription",
  "/usage-statistics": "view_usage_history",
  // Security
  "/permissions": "view_client_permissions",
  "/assign-permission": "add_client_permission",
  // WorkFlow
  "/workflows": "view_workflow",
  "/workflow-edit": "add_workflow",
  "/workflow-assign-list": "assign_list_workflow",
  "/workflow-assign": "assign_workflow",
  "/workflows-running": "view_workflow_running",
  "/workflow-instances": "view_workflow_instance",
  "/workflow-instances-history": "view_workflow_instance_history",
};
const ProtectedRoute = () => {
  const { isAuthenticated, hasPermission, isLoading } = usePermissions();
  const location = useLocation();
  const currentPath = location.pathname;
  // Apply 70% zoom for protected routes
  useEffect(() => {
    const applyZoom = () => {
      document.documentElement.style.zoom = "70%";
      if (getComputedStyle(document.documentElement).zoom === "1") {
        document.documentElement.style.transform = "scale(0.7)";
        document.documentElement.style.transformOrigin = "top left";
        document.documentElement.style.width = "142.857%";
        document.documentElement.style.height = "142.857vh";
      }
    };
    applyZoom();
    // Cleanup function to reset zoom when leaving protected routes
    return () => {
      document.documentElement.style.zoom = "100%";
      document.documentElement.style.transform = "";
      document.documentElement.style.transformOrigin = "";
      document.documentElement.style.width = "";
      document.documentElement.style.height = "";
    };
  }, []);
  if (isLoading) {
    return <LoadingComponent variant="fullScreen" />;
  }
  if (!isAuthenticated) {
    return <Navigate to="/sign-in" state={{ from: location }} replace />;
  }
  // Check permissions for the current route
  const requiredPermission = Object.keys(routePermissions).find((route) => {
    const routePattern = route.replace(/:[^/]+/, "[^/]+");
    const regex = new RegExp(`^${routePattern}$`);
    return regex.test(currentPath);
  });
  if (
    requiredPermission &&
    !hasPermission(routePermissions[requiredPermission])
  ) {
    return <Navigate to="/access-denied" state={{ from: location }} replace />;
  }
  return (
    <MasterLayout>
      <Outlet />
    </MasterLayout>
  );
};
export default ProtectedRoute;